import { Box, styled, Typography } from '@mui/material';

import AureaBgLoginPage from '../../../assets/img/AUREA_bg-login.webp';
import AureaBgLoginPageMD from '../../../assets/img/AUREA_bg-login-md.webp';
import AureaBgLPage from '../../../assets/img/AUREA_bg-lpage.webp';
import AureaBgLPageSM from '../../../assets/img/AUREA_bg-lpage-sm.webp';
import AureaBgOnboardingPage from '../../../assets/img/AUREA_bg-onboarding.webp';
import AureaBgOnboardingPageMD from '../../../assets/img/AUREA_bg-onboarding-md.webp';
import AureaBgOnboardingPageSM from '../../../assets/img/AUREA_bg-onboarding-sm.webp';

export const BoxBackgroundImageStyled = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isFormPage' &&
    prop !== 'isLoginPage' &&
    prop !== 'isOnboardingPage' &&
    prop !== 'isOnboardingAdvancedSteps',
})(({
  theme,
  isFormPage,
  isLoginPage,
  isOnboardingPage,
  isOnboardingAdvancedSteps,
}) => {
  const getBackgroundImage = () => {
    if (isLoginPage) return AureaBgLoginPage;

    if (isOnboardingPage) return AureaBgOnboardingPage;

    return AureaBgLPage;
  };

  const getSmallBackgroundImage = () => {
    if (isLoginPage) return AureaBgLoginPage;

    if (isOnboardingPage) return AureaBgOnboardingPageMD;

    return AureaBgLPageSM;
  };

  const getBackgroundImageBetweenSmMd = () => {
    if (isLoginPage) return AureaBgLoginPage;

    if (isOnboardingPage) return AureaBgOnboardingPageSM;

    return AureaBgLPage;
  };

  const getBackgroundImageBetweenMdLg = () => {
    if (isLoginPage) return AureaBgLoginPageMD;

    if (isOnboardingPage) return AureaBgOnboardingPageMD;

    return AureaBgLPage;
  };

  return {
    backgroundImage: `url(${getBackgroundImage()})`,
    backgroundPosition: 'top',
    width: '100%',
    height: isFormPage ? 416 : 'fill-available',
    minHeight: isFormPage ? 416 : 650,
    backgroundSize: 'cover',
    position: 'relative',

    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${getSmallBackgroundImage()})`,
      backgroundPosition: isFormPage ? 'center' : 'right',
      height: isFormPage ? 216 : 'fill-available',
      minHeight: isFormPage ? 216 : 450,
    },
    [theme.breakpoints.between('sm', 'md')]: {
      backgroundImage: `url(${getBackgroundImageBetweenSmMd()})`,
    },
    [theme.breakpoints.between('md', 'lg')]: {
      backgroundImage: `url(${getBackgroundImageBetweenMdLg()})`,
    },
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      justifyContent: !isFormPage && 'center',
      width: isFormPage && '50%',
      height: isFormPage && '100%',
      minHeight: isFormPage && 'auto',
    },
    [theme.breakpoints.up('xxl')]: {
      width: isOnboardingAdvancedSteps && '532px',
    },
    [theme.breakpoints.up('xxxxl')]: {
      width: isOnboardingAdvancedSteps && '640px',
    },
  };
});

export const TextContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isFormPage',
})(({ theme, isFormPage }) => ({
  position: 'absolute',
  bottom: 0,
  margin: isFormPage ? '0 0 30px 32px' : '0 0 89px 32px',

  [theme.breakpoints.down('sm')]: {
    margin: isFormPage ? '0 0 20px 25px' : '0 0 25px 20px',
  },
  [theme.breakpoints.up('lg')]: {
    width: isFormPage ? '448px' : 916,
    margin: isFormPage ? '0 0 40px 50px' : '0 0 48px',
  },
  [theme.breakpoints.up('xxl')]: {
    width: isFormPage ? '656px' : '1184px',
    margin: !isFormPage && '0 0 80px',
  },
  [theme.breakpoints.up('xxxxl')]: {
    width: !isFormPage && '1408px',
    margin: !isFormPage && '0 0 48px',
  },
}));

export const LandingPageText = styled(Typography, {
  shouldForwardProp: (prop) =>
    prop !== 'isFormPage' && prop !== 'isOnboardingAdvancedSteps',
})(({ theme, isFormPage, isOnboardingAdvancedSteps }) => ({
  display: isFormPage && 'none',
  maxWidth: 350,
  fontFamily: 'Flama Light',
  color: theme.palette.colors.onImageBackground,
  fontSize: '40px',
  textTransform: 'uppercase',
  textWrap: 'balance',
  letterSpacing: 'normal',
  lineHeight: 1.15,

  [theme.breakpoints.down('sm')]: {
    maxWidth: 190,
    fontSize: '25px',
    fontWeight: 'normal',
    lineHeight: 1.4,
  },
  [theme.breakpoints.up('lg')]: {
    display: isOnboardingAdvancedSteps && 'none',
  },
}));
